import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import DatePicker from "react-multi-date-picker";
import moment from "moment";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const MonthRangePicker = ({ defaultValue, onChangeMonthRange }) => {
  const [value, setValue] = React.useState(defaultValue || [new Date()]);

  const handleChange = dates => {
    if (dates?.length > 1) {
      setValue(dates);
      
      const selectedDateStart = moment(`${dates[0]["year"]}-${dates[0]["month"]}-${dates[0]["day"]}`);
      const selectedDateEnd = moment(`${dates[1]["year"]}-${dates[1]["month"]}-${dates[1]["day"]}`);
      const firstDayOfMonth = selectedDateStart.clone().startOf('month');
      const lastDayOfMonth = selectedDateEnd.clone().endOf('month');

      let start_date = new Date(
        `${dates[0]["year"]}-${dates[0]["month"]}-${dates[0]["day"]}`
      );
      let end_date = new Date(
        `${dates[1]["year"]}-${dates[1]["month"]}-${dates[1]["day"]}`
      );

      let formatting_end = new Date(
        end_date.getFullYear(),
        end_date.getMonth() + 1,
        1
      )
        .toJSON()
        .split("T")[0];
      start_date.setDate(start_date.getDate() + 1);

      let date = {
        start_date: firstDayOfMonth.format('YYYY-MM-DD') || start_date.toJSON().split("T")[0],
        end_date: lastDayOfMonth.format('YYYY-MM-DD') || formatting_end,
      };
      onChangeMonthRange(date);
    }
  };

  return (
    <MonthRangePickerStyled>
      <DatePicker
        value={value}
        onChange={handleChange}
        months={months}
        onlyMonthPicker
        range
        inputClass="month-range--input"
        containerClassName="month-range--container"
        arrowClassName="month-range--arrow"
        renderButton={(direction, handleClick) => (
          <i
            className={`mdi mdi-arrow-${
              direction === "right"
                ? "right-drop-circle-outline me-1"
                : "left-drop-circle-outline ms-1"
            } arrow-calendar`}
            onClick={handleClick}
          />
        )}
      />
    </MonthRangePickerStyled>
  );
};

MonthRangePicker.propTypes = {
  defaultValue: PropTypes.array,
  onChangeMonthRange: PropTypes.func,
  withLastDayInMonth: PropTypes.bool,
};

const MonthRangePickerStyled = styled.div`
  .month-range--container {
    max-width: 230px;

    &:nth-child(1) {
      top: 15px;
    }

    .ep-arrow.month-range--arrow::after {
      top: 5px;
      background-color: rgba(0, 0, 0, 0.1);
      box-shadow: none !important;
    }

    .arrow-calendar {
      font-size: 18px;
      transition: color 0.3s ease-in-out;

      &:hover {
        cursor: pointer;
        color: rgb(61, 145, 255) !important;
      }
    }

    .month-range--input {
      width: 100%;
      padding-left: 10px;
      height: 38px;
      border: 1px solid #ced4da;
      position: relative;
      outline: 0;
      background-color: #fff;
      border-radius: 4px;
      color: #495057;
    }

    .rmdp-wrapper {
      /* #495057 */

      .month-range--arrow {
        &.rmdp-ep-shadow::after {
          box-shadow: none !important;
        }
      }

      &.rmdp-shadow {
        box-shadow: none !important;
        border: 1px solid rgba(0, 0, 0, 0.1);
      }
      &.rmdp-ep-shadow:after {
        box-shadow: none !important;
      }

      .mdp-range {
        background-color: rgb(61, 145, 255) !important;
      }

      .rmdp-day {
        span {
          color: #495057;

          &:hover {
            background-color: rgba(61, 145, 255, 0.3) !important;
          }
        }

        &.rmdp-range {
          background-color: rgb(61, 145, 255) !important;

          span {
            color: #fff;
          }
        }
      }

      .rmdp-today {
        span {
          background-color: rgb(61, 145, 255, 0) !important;
          font-weight: 700 !important;
          color: #000;

          &:hover {
            /* background-color: rgba(61, 145, 255, 0.3) !important; */
          }
        }
      }
    }
  }
`;

export default MonthRangePicker;
